import { useQuery } from '@tanstack/react-query'
import { ApiError } from '@/shared/lib/api/api-client'
import { fetchRoles } from './roles-api'

/**
 * The tenant's roles, shared by the roles page and every dialog that assigns
 * roles. `GET api/roles` is gated on `UserManagement` READ, so a dialog opened
 * from a page with another gate (groups) can be refused: `isForbidden` lets it
 * explain that instead of showing an empty list (UC-084.2 E6).
 */
export function useRolesQuery({ enabled = true }: { enabled?: boolean } = {}) {
  const query = useQuery({ queryKey: ['roles'], queryFn: fetchRoles, enabled })
  return {
    roles: query.data ?? [],
    isLoading: query.isLoading,
    isForbidden: query.error instanceof ApiError && query.error.status === 403,
  }
}
